import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface InstagramIconProps extends SvgIconProps {}

export const InstagramIcon = ({
  style,
  ...iconProps
}: InstagramIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M13.503 6.57754C9.67211 6.57754 6.5821 9.66825 6.5821 13.5C6.5821 17.3318 9.67211 20.4225 13.503 20.4225C17.3339 20.4225 20.4239 17.3318 20.4239 13.5C20.4239 9.66825 17.3339 6.57754 13.503 6.57754ZM13.503 18.0005C11.0274 18.0005 9.00351 15.9822 9.00351 13.5C9.00351 11.0178 11.0214 8.9995 13.503 8.9995C15.9847 8.9995 18.0025 11.0178 18.0025 13.5C18.0025 15.9822 15.9786 18.0005 13.503 18.0005ZM22.3213 6.29438C22.3213 7.19207 21.5985 7.90902 20.707 7.90902C19.8095 7.90902 19.0928 7.18604 19.0928 6.29438C19.0928 5.40271 19.8156 4.67974 20.707 4.67974C21.5985 4.67974 22.3213 5.40271 22.3213 6.29438ZM26.9051 7.93311C26.8027 5.77022 26.3088 3.85435 24.7247 2.27586C23.1465 0.697367 21.2311 0.203336 19.0687 0.0948901C16.84 -0.03163 10.16 -0.03163 7.93134 0.0948901C5.77496 0.197311 3.85951 0.691342 2.27535 2.26983C0.691188 3.84832 0.203291 5.7642 0.0948689 7.92709C-0.031623 10.1563 -0.031623 16.8377 0.0948689 19.0669C0.197267 21.2298 0.691188 23.1457 2.27535 24.7241C3.85951 26.3026 5.76893 26.7967 7.93134 26.9051C10.16 27.0316 16.84 27.0316 19.0687 26.9051C21.2311 26.8027 23.1465 26.3087 24.7247 24.7241C26.3028 23.1457 26.7967 21.2298 26.9051 19.0669C27.0316 16.8377 27.0316 10.1623 26.9051 7.93311ZM24.0259 21.4587C23.5561 22.6396 22.6466 23.5493 21.46 24.0253C19.683 24.7302 15.4666 24.5675 13.503 24.5675C11.5394 24.5675 7.31695 24.7241 5.54607 24.0253C4.36548 23.5553 3.45594 22.6456 2.98009 21.4587C2.27535 19.6814 2.43798 15.4641 2.43798 13.5C2.43798 11.5359 2.28137 7.31256 2.98009 5.54128C3.44992 4.36043 4.35945 3.45069 5.54607 2.97473C7.32298 2.26983 11.5394 2.4325 13.503 2.4325C15.4666 2.4325 19.6891 2.27586 21.46 2.97473C22.6405 3.44466 23.5501 4.3544 24.0259 5.54128C24.7307 7.31859 24.568 11.5359 24.568 13.5C24.568 15.4641 24.7307 19.6874 24.0259 21.4587Z"
        fill="white"
      />
    </SvgIcon>
  );
};
